<template>
  <div class="main-width">
    <div class="project-search page-search home-height" style="margin-top: -10px; padding-top: 68px">
      <div style="display: flex; flex-direction: column; margin-bottom: 40px">
        <div>
          <p style="font-weight: bold; margin-left: 70px; font-size: 22px">
            Search for Target in Whole Database:
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-input
            v-model="targetFullText"
            placeholder="Enter the keyword"
            style="width: 900px; font-size: 20px"
            class="project-input"
          >
          </el-input>
          <el-button
            class="btn-submit page-btn"
            @click="submitTargetFullText()"
            style="font-size: 22px; width: 120px"
            >Search</el-button
          >
        </div>

        <p style="margin-left: 70px; font-size: 18px">
          Example:
          <a
            href="/search-target?api=fullText&keyword=Glutamate carboxypeptidase 2"
            hreflang="en"
            class="search-color"
            >Glutamate carboxypeptidase 2</a
          >; <a
            href="/search-target?api=fullText&keyword=SSTR2"
            hreflang="en"
            class="search-color"
            >SSTR2</a
          >; <a
            href="/search-target?api=fullText&keyword=Acetylcholinesterase "
            hreflang="en"
            class="search-color"
            >Acetylcholinesterase </a
          >; <a
            href="/search-target?api=fullText&keyword=Piflufolastat F-18 "
            hreflang="en"
            class="search-color"
            >Piflufolastat F-18 </a
          >

          
          ...
        </p>
      </div>
    </div>

    <div class="project-search page-search" style="margin-top: 50px">
      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Target by Target Name:
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="target_name_list_check"
            v-model="target_name"
            filterable
            default-first-option
            placeholder="Please select target name"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in target_name_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitTarget()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div>

      <!-- <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Target by Drug Name:
          </p>
        </div>

        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="drug_name_list_check"
            v-model="drug_name"
            filterable
            default-first-option
            placeholder="Please select a drug name"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in drug_name_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitDrugName()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div> -->

      <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 78px; font-size: 22px">
            Search for Target by Drug Type & Drug Name:
          </p>
        </div>
        <div>
          <p style="margin-left: 78px; font-size: 18px">
            <i class="icon iconfont icon--idea" aria-hidden="true"></i> Tips:
            Please select the drug type first, then a list of drug name under
            the selected class will be available for selection.
          </p>
        </div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="drug_type_list_check"
            v-model="drug_type"
            filterable
            default-first-option
            placeholder="Step1: Please select a drug type"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in drug_type_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="resetTypeDrug()"
            style="font-size: 22px; width: 120px"
            >Reset</el-button
          >
        </div>
        <div style="height: 10px"></div>
        <div style="display: flex; margin: 0 auto">
          <el-select
            v-loading="drug_name_list_check"
            v-model="drug_name"
            filterable
            default-first-option
            ref="searchSelect"
            placeholder="Step2: Please select a drug name"
            style="width: 900px"
          >
            <el-option
              v-for="(item, index) in drug_name_list"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>

          <el-button
            class="btn-submit page-btn"
            @click="submitTypeDrug()"
            style="font-size: 22px; width: 120px"
            >Submit</el-button
          >
        </div>
      </div>

      <!-- <div style="display: flex; flex-direction: column; margin-bottom: 50px">
        <div>
          <p style="font-weight: bold; margin-left: 70px; font-size: 22px">
            Search for Target by Sequence Similarity: (
            <span @click="fastaExample('example1')" class="input_example"
              ># Example1</span
            >,
            <span @click="fastaExample('example2')" class="input_example">
              # Example2</span
            >,
            <span @click="fastaExample('example3')" class="input_example"
              ># Example3</span
            >
            )
          </p>
        </div>
        <div style="margin-left: 62px">
          <el-input
            type="textarea"
            v-model="seq_text"
            rows="6"
            style="width: 1022px"
            class="protein-input"
          ></el-input>
        </div>
        <div
          style="display: flex; justify-content: space-evenly; margin-top: 20px"
        >
          <el-button
            class="btn-submit page-btn"
            @click="fastaReset()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Reset</el-button
          >
          <el-button
            class="btn-submit page-btn"
            @click="fastaSubmit()"
            style="font-size: 22px; width: 120px; border-radius: 10px"
            >Submit</el-button
          >
        </div>
      </div> -->
    </div>
    <div style="height: 20px"></div>
  </div>
</template>
  
  <script>
import api from "@/api/index";
import pathUrl from "@/api/path";

export default {
  data() {
    return {
      localUrl: pathUrl.localUrl,
      seq_text: "",

      targetFullText: "",

      target_name_list_check: true,
      target_name: "",
      target_name_list: [],

      drug_type_list_check: true,
      drug_type: "",
      drug_type_list: [],
      drug_name_list_check: false,
      drug_name: "",
      drug_name_list: [],
    };
  },
  components: {
    // DivUnit,
  },

  methods: {
    fastaExample(example) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", `/fasta/${example}.fasta`, false);
      xhr.overrideMimeType("text/html;charset=utf-8");
      xhr.send(null);
      this.seq_text = xhr.responseText;
    },
    fastaReset() {
      this.seq_text = "";
    },
    fastaSubmit() {
      var mission_id = "" + new Date().getTime();
      var post_data = {
        seq_text: this.seq_text,
        mission_id: mission_id,
      };
      console.log(post_data);
      if (this.seq_text.trim() == "") {
        this.$alert("Please enter the correct protein sequence", "Error", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Close",
        });
      } else {
        api.postTargetSequence(post_data).then((res) => {
          console.log(res);
        });
        this.$router.push("/target-similarity?jobID=" + mission_id);
      }
    },

    submitTargetFullText() {
      this.$router.push({
        path: `/search-target`,
        query: {
          api: "fullText",
          keyword: this.targetFullText,
        },
      });
    },
    submitTypeDrug() {
      this.$router.push({
        path: `/search-target`,
        query: {
          api: "search-target-by-drug",
          group: this.drug_type,
          keyword: this.drug_name,
        },
      });
    },
    submitTarget() {
      this.$router.push({
        path: `/search-target`,
        query: {
          api: "search-target-by-target",
          keyword: this.target_name,
        },
      });
    },
    resetTypeDrug() {
      this.drug_type='';
      this.drug_name='';
    },
  },

  beforeMount() {},
  mounted() {
    api.getSearchTargetList().then((res) => {
      this.target_name_list_check = false;
      this.drug_type_list_check = false;
      this.target_name_list = res.data.target_name_list;
      this.drug_type_list = res.data.drug_type_list;
    });
  },
  watch: {
    drug_type: {
      handler: function () {
        this.drug_name_list_check = true;
        this.drug_name = "";
        api
          .postTypeDrugList({
            data: this.drug_type,
            type: "target",
          })
          .then((res) => {
            this.drug_name_list_check = false;
            this.drug_name_list = res.data.drug_name_list;
          });
      },
      deep: true,
    },
  },
};
</script>
<style lang="less" scoped>
@color-theme: #548235;
@color-bg: #548235ba;

/deep/input {
  height: 50px;
  padding-left: 15px;
  font-size: 20px;
  border: 2px solid @color-theme !important;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  outline: none;
}


.page-search {
  border: 3px solid @color-theme;
  background-color: #f2f6ef;
}
.page-search-color {
  color: @color-theme;
}
.search-color{
color: @color-theme;
}
.page-btn {
  background: @color-theme;
}
.page-btn:hover {
  background: @color-bg;
}
.page-btn:hover,
.page-btn:active,
.page-btn:focus {
  background: @color-bg;
}
/deep/.el-button {
  font-size: 22px !important;
  height: 50px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px;
}
</style>
  